import { TransactionQueryKeys } from '@/modules/transaction/keys'
import {
	GetSmsAutoLogsParams,
	PaginatedSmsAutoTransactionLogsResponse,
} from '@/modules/transaction/types'
import { UnusedSkipTokenOptions } from '@tanstack/react-query'
import BankTransactionService from '../../services'

export const querySmsAutoLogsOptions = (
	payload: GetSmsAutoLogsParams,
	options?: UnusedSkipTokenOptions<PaginatedSmsAutoTransactionLogsResponse>,
) => ({
	queryKey: [TransactionQueryKeys.SMS_AUTO_LOGS, payload],
	queryFn: () => BankTransactionService.getSmsAutoTransactionLogs(payload),
	...options,
})
